// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CrownOutlinedSvg from "@fishx/icons-svg/es/asn/CrownOutlined";
import FishxIcon from '../components/FishxIcon';

var CrownOutlined = function CrownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CrownOutlinedSvg
  }));
};

CrownOutlined.displayName = 'CrownOutlined';
export default React.forwardRef(CrownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CrownOutlined.js
// module id = 2352
// module chunks = 0